export class DocumentsApi {
  public static readonly getNeeded: string = '/file/needed';
  public static readonly getAll: string = '/file/all';
  public static readonly upload: string = '/file/add';
  public static readonly findById: string = '/file/findById';
  public static readonly delete: string = '/file/delete';
  public static readonly sign: string = '/file/sign';
  public static readonly callback: string = '/file/callback';
}
